import { useState } from 'react';
import { Button } from './Button';
import { buildShareUrl } from '../utils/format';

export function ShareLinkButton({ shortCode }: { shortCode: string }) {
  const [copied, setCopied] = useState(false);
  const url = buildShareUrl(shortCode);

  const onClick = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt('Copy this link:', url);
    }
  };

  return (
    <div className="stack">
      <Button variant="accent" onClick={onClick} block>
        {copied ? 'Copied!' : `Copy share link · ${shortCode}`}
      </Button>
      <span className="muted" style={{ fontSize: 12, textAlign: 'center', wordBreak: 'break-all' }}>{url}</span>
    </div>
  );
}
